var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8126 20.4115H5.61344C5.33176 20.4115 5.10315 20.6401 5.10315 20.9218V21.9424C5.10315 22.2246 5.33176 22.4527 5.61344 22.4527H18.8126C19.0942 22.4527 19.3228 22.2246 19.3228 21.9424V20.9218C19.3228 20.6401 19.0942 20.4115 18.8126 20.4115ZM5.55201 12.0096C4.95395 11.4121 4.95344 10.443 5.55099 9.84448L5.91176 9.4837L11.3223 14.8882V2.04115H13.3635V14.8856L18.7649 9.48421L19.1257 9.84499C19.7237 10.4425 19.7237 11.4121 19.1257 12.0101L12.3434 18.7929L5.55201 12.0096Z",
    fill: "#E87722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e85921db9f2704184f1d799afc04ced8.svg";
export { ForwardRef as ReactComponent };